export default __webpack_public_path__ + "static/problemImg-fb173f9a969d7bb3e908fd79ac3e59e3.png";